import { IFieldContainer, IFieldDefinition, IFormConfig } from 'app/interfaces';
import { fieldsMap } from '../fields';

const formFields: (IFieldContainer|IFieldDefinition)[] = [
	fieldsMap.get('resource_code'),
	fieldsMap.get('resource_description'),
	fieldsMap.get('package_resource_type')
];

const config: IFormConfig = {
	fields: formFields 
};

export default config;
